export default __webpack_public_path__ + "static/media/pointing-finger.e8d057dc.png";